import React, { useRef } from 'react';

import styles from './InputTitleWrap.module.scss';

interface Props {
  children: React.ReactNode;
  title: string;
  testId?: string;
  tabIndex?: number;
}

const focusOnFirstInput = (ref: React.RefObject<HTMLDivElement>): void => {
  if (ref.current && ref.current instanceof HTMLElement) {
    const focusableElement = ref.current.querySelector<HTMLElement>(
      'input, textarea, select, button, [tabindex]:not([tabindex="-1"])'
    );
    focusableElement?.focus();
  }
};

const InputTitleWrap: React.FC<Props> = ({ children, title, testId, tabIndex }) => {
  const ref = useRef<HTMLDivElement>(null);

  const handleClick = (): void => {
    focusOnFirstInput(ref);
  };

  const handleKeyDown = (e: React.KeyboardEvent): void => {
    if (e.key === 'Enter') {
      focusOnFirstInput(ref);
    }
  };

  const handleFocus = (e: React.FocusEvent<HTMLDivElement>): void => {
    if (e.target === e.currentTarget) {
      focusOnFirstInput(ref);
    }
  };

  return (
    <div
      className={styles.Outer}
      data-testid={testId || ''}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      onFocus={handleFocus}
      ref={ref}
      role="button"
      tabIndex={tabIndex}
    >
      <span>{title}</span>
      <div>{children}</div>
    </div>
  );
};

export default InputTitleWrap;
